import { useTranslation } from 'react-i18next';

export default function GalleryHero({ image }: { image?: string }) {
  const { t } = useTranslation();

  return (
    <section className="relative pt-24 pb-16 md:pt-32 md:pb-20 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={image || "https://static.readdy.ai/image/3aca7b4f25b4386bcee0afd7be9c4116/4fa68d06832c867a32619c653b1f915f.png"}
          alt="Bucara Burger Gallery – Colombian food truck Boise Idaho"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/95"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/50"></div>
      </div>

      {/* Decorative bottom line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#F57F25]/50 to-transparent"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-[#F57F25]/15 border border-[#F57F25]/30 text-[#F57F25] text-xs font-bold px-4 py-2 rounded-full uppercase tracking-widest mb-6">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-image-line text-xs"></i>
          </div>
          {t('gallery_page_badge')}
        </div>

        <h1 className="text-5xl md:text-7xl font-black text-white uppercase tracking-tight leading-none mb-5">
          {t('gallery_page_title')} <span className="text-[#F57F25]">{t('gallery_page_title_accent')}</span>
        </h1>

        <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-6">
          {t('gallery_page_sub')}
        </p>

        {/* Intro text */}
        <p className="text-white/45 text-sm max-w-xl mx-auto leading-relaxed">
          {t('gallery_page_intro')}
        </p>

        {/* Scroll indicator */}
        <div className="mt-10 flex justify-center">
          <div className="w-px h-12 bg-gradient-to-b from-[#F57F25] to-transparent"></div>
        </div>
      </div>
    </section>
  );
}
